import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { PageHeader } from 'src/components/payments-ops/PageHeader'
import { ReconciliationForm } from 'src/components/payments-ops/reconciliation/ReconciliationForm'
import { ReconciliationResultCard } from 'src/components/payments-ops/reconciliation/ReconciliationResultCard'
import { NoAccessCard } from 'src/components/shared/NoAccessCard'
import { InternalPermission } from 'src/constants/internal-access/internalPermissions'
import { PARTNERS_REQUIRED_MESSAGE } from 'src/constants/payments-ops/constants'
import { useHasPermission } from 'src/hooks/useHasPermission'
import { getReconciliationError, getReconciliationRun } from 'src/selectors/reconciliation'

const ReconciliationPageComponent = () => {
  const run = useSelector(getReconciliationRun)
  const error = useSelector(getReconciliationError)
  // A run is per partner, picked from `GET /partners` (`partners_view`) — skipped by
  // PaymentsOpsLayout without it, so the form would have nothing to pick (spec §6, §10.2).
  const canViewPartners = useHasPermission(InternalPermission.PartnersView)

  return (
    <div
      data-testid="reconciliation-page"
      css={tw`flex min-h-0 min-w-0 flex-1 flex-col gap-4 overflow-auto p-6`}
    >
      <PageHeader
        title="Reconciliation"
        description="Reconcile one partner's US Bank virtual-account transactions from a start date to today."
      />
      {canViewPartners ? (
        <ReconciliationForm />
      ) : (
        <NoAccessCard
          message={PARTNERS_REQUIRED_MESSAGE}
          dataTestId="reconciliation-no-partner-access"
        />
      )}
      {error ? (
        <Typography variant="body2" css={tw`text-critical-500`}>
          {error}
        </Typography>
      ) : null}
      {run ? <ReconciliationResultCard run={run} /> : null}
    </div>
  )
}

export const ReconciliationPage = memo(ReconciliationPageComponent)
